import template from './s3-file-browser.html';
import controller from './s3-file-browser.controller';

let s3FileBrowserComponent = {
  restrict: 'E',
  bindings: {
    baseApiUrl: '@', // Base API URL for S3 operations (e.g., /api/admin/contracts/{id}/documents/s3)
    allowedFileTypes: '@', // Optional: comma-separated list of allowed file types
    maxFileSize: '@' // Optional: max file size in bytes
  },
  template,
  controller
};

export default s3FileBrowserComponent;




// WEBPACK FOOTER //
// ./client/common/directives/s3-file-browser/s3-file-browser.component.js